<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-row v-if="errors">
                <v-col cols="12" sm="12" md="12">
                  <v-alert
                    dense
                    v-for="(v, k) in errors"
                    :key="k"
                    outlined
                    type="error"
                  >{{ k }} {{ v }}</v-alert>
                </v-col>
              </v-row>
              <v-card-title v-if="!equip_group_id">{{ 'Add Equipment Group' | translate }}</v-card-title>
              <v-card-title v-if="equip_group_id">{{ 'Edit Equipment Group' | translate }}</v-card-title>
              <v-card-text style="position: relative">
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Equipment group name' | translate"
                            name="equip_group_name"
                            v-model="equip_group_name"
                            autocomplete="off"
                            :rules="equipgroupnameRules"
                            required
                          >
                          <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    </v-col>
                  </v-row>
                </v-form>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="!equip_group_id"
                  class="mx-2"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  v-if="equip_group_id"
                  class="mx-2"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container> 
  </v-content>
</template>  

<script>
import {
  FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA,
  ADD_EQUIPMENT_GROUP_DATA,
  UPDATE_EQUIPMENT_GROUP_DATA,
  RESET_STATE
} from "@/store/actions.type";
import store from "@/store";
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import { SET_SNACKBAR } from "@/store/mutations.type"
export default {
  name: "addeditEquipmentGroups",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    if (to.params.id) {
      await store.dispatch(FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA, to.params.id);
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualequipmentgroup","curLanguage"]),
    ...mapState({
      errors: state => state.equipmentgroups.equipmentgrouperrors
    }),
    equipgroupnameRules(){
     return [v => !!v || "Equipment group name is required"]
    }
  },
  created(){
      if(Object.keys(this.individualequipmentgroup).length > 0){
      this.equip_group_name = this.individualequipmentgroup.equip_group_name
      this.equip_group_id  =   this.individualequipmentgroup.equip_group_id
      }   
  },
  data: () => ({
    equip_group_name: null,
    equip_group_id: null,
  }),
  methods: {
    submit() {
        if (this.$refs.form.validate()) {
            var formData = new FormData(document.getElementById("form"));
            this.$store.dispatch(ADD_EQUIPMENT_GROUP_DATA, formData).then(resp => {
            if (resp.success) {
               store.commit(SET_SNACKBAR, {status: true, message: 'Equipment group added successfully'})
                this.$router.push({
                name: "equipmentgroup"
                });
            }
            });            
            
        }
    },
    update() {
        if (this.$refs.form.validate()) {
        var formData = new FormData(document.getElementById("form"));
        formData.set("equip_group_id", this.equip_group_id);
        formData.set("_method", "put");
        this.$store.dispatch(UPDATE_EQUIPMENT_GROUP_DATA, formData).then(resp => {
        if (resp.success) {
            store.commit(SET_SNACKBAR, {status: true, message: 'Equipment group updated successfully'})
            this.$router.push({
            name: "equipmentgroup",
            });
        }
        });              
        }        
    }
  }
};
</script>